<template>
  <v-dialog v-model="form_url_modal" width="500" :retain-focus="false">
    <v-card>
      <v-card-title class="primary py-2 pr-2">
        <div class="d-flex justify-space-between align-center w-full white--text">
          <div>
            <v-icon class="mr-2" color="white">mdi-link-variant</v-icon>
            {{ $store.state.form_url.id ? "Update" : "Add" }} Bookmark
          </div>
          <v-btn icon>
            <v-icon @click="form_url_modal = false">mdi-close</v-icon>
          </v-btn>
        </div>
      </v-card-title>

      <div class="pa-2">
        <v-text-field
          label="URL"
          outlined
          hide-details
          clearable
          v-model.trim="form_url_url"
          @keyup.enter="$store.dispatch('submitUrl')"
          tabindex="1"
          ref="form_url_url"
          class="mt-6"
          prepend-inner-icon="mdi-link-variant"
        ></v-text-field>
        <v-text-field
          ref="form_url_name"
          class="mt-6"
          label="Title"
          outlined
          hide-details
          clearable
          prepend-inner-icon="mdi-format-title"
          v-model.trim="form_url_name"
          @keyup.enter="$store.dispatch('submitUrl')"
          tabindex="2"
        ></v-text-field>

        <div class="mt-3" v-if="form_name_suggestions.length">
          <v-chip
            class="mr-2 mb-2"
            v-for="(suggestion, index) in form_name_suggestions"
            :key="'suggestion' + index"
            v-text="suggestion"
            label
            outlined
            link
            @click="clickTitleSuggestion(suggestion)"
          />
        </div>

        <v-textarea
          :class="form_name_suggestions.length ? 'mt-2' : 'mt-6'"
          outlined
          label="Note"
          v-model="form_url_note"
          prepend-inner-icon="mdi-note-outline"
          auto-grow
          no-resize
          rows="1"
          tabindex="3"
          clearable
          hide-details
          @keyup.ctrl.enter="$store.dispatch('submitUrl')"
        ></v-textarea>

        <div class="d-flex justify-center align-center w-full mt-6">
          <div class="flex-grow-1">
            <ParentSelector v-model="form_url_location" tabindex="4" v-shortkey.avoid />
          </div>

          <div class="flex-shrink-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span v-on="on">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    large
                    color="primary"
                    class="ml-2"
                    @click="$store.dispatch('clickAddFolder')"
                  >
                    <v-icon>mdi-folder-plus-outline</v-icon>
                  </v-btn>
                </span>
              </template>
              <span>New Folder</span>
            </v-tooltip>
          </div>
        </div>

        <v-btn
          x-large
          :loading="$store.state.form_url_loading"
          block
          outlined
          color="primary"
          class="mt-10"
          @click="$store.dispatch('submitUrl')"
          tabindex="5"
        >
          save URL
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import ParentSelector from "./ParentSelector";
export default {
  name: "ModalURL",
  components: { ParentSelector },
  data() {
    return {
      nameSuggestionProcessId: null,
    };
  },
  watch: {
    form_url_modal(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.form_url_url.$refs.input.focus();
          }, 200);
        });

        setTimeout(() => {
          // data needs to be loaded
          const bookmarkleturl = new URL(window.location.href).searchParams.get("bookmarkleturl");
          if (bookmarkleturl) {
            const recent_bookmarklet_folder = localStorage.getItem("recent_bookmarklet_folder");
            if (recent_bookmarklet_folder) {
              const item = this.$store.state.bookmarks[recent_bookmarklet_folder];
              if (item) {
                this.$store.commit("updateStateFormURL", {
                  location: {
                    id: item.id,
                    label: item.label,
                  },
                });
              }
            }
          }
        }, 1000);
      }
    },
    form_url_url(newValue) {
      clearInterval(this.nameSuggestionProcessId);
      this.nameSuggestionProcessId = setTimeout(() => {
        this.suggestName(newValue);
      }, 500);
    },
  },
  //   form_url_url(newValue) {
  //     if (
  //       newValue !== null &&
  //       newValue.length &&
  //       (this.form_url_name === null || !this.form_url_name.length)
  //     ) {
  //       const url = newValue.toLowerCase();
  //       var url_match = url.match(/(?:https?:\/\/)?(?:[^./]+\.)?([^./]+)(?:\.[^./]+)/);
  //       console.log(url_match, "url_match");
  //       if (url_match) {
  //         const newName = url_match[1].charAt(0).toUpperCase() + url_match[1].slice(1);
  //         this.$store.commit("updateStateFormURL", { name: newName });
  //       } else {
  //         console.error("URL can not be parsed!");
  //       }
  //     }
  //   },
  // },
  methods: {
    clickTitleSuggestion(value) {
      if (this.form_url_name && this.form_url_name.length) {
        this.form_url_name += " ";
      }
      this.form_url_name = (this.form_url_name ? this.form_url_name : "") + value;
      this.$refs.form_url_name.focus();
    },
    suggestName(newValue) {
      // debugger;
      if (newValue == null || !newValue.length) {
        this.$store.commit("updateStateFormURL", { name_suggestions: [] });
      } else {
        let string = newValue;
        let url = null;
        try {
          url = new URL(newValue);
        } catch (e) {
          string = "http://" + string;
        }

        try {
          url = new URL(string);
        } catch (e) {
          console.error("invalid URL");
          this.$store.commit("updateStateFormURL", { name_suggestions: [newValue] });
          return;
        }

        let suggestions = ["|", "-"];

        // hostname
        let hostname_parts = url.hostname
          .split(".")
          .sort((a, b) => b.length - a.length)
          .filter((v) => v.length > 1 && v.length < 20);
        //capitalization
        hostname_parts.forEach((v, i, arr) => {
          if (v.length < 7) {
            arr[i] = v.toLocaleUpperCase();
          } else {
            arr[i] = v.charAt(0).toUpperCase() + v.slice(1);
          }
        });
        suggestions = suggestions.concat(hostname_parts);

        // pathname
        if (url.pathname.length && url.pathname != "/") {
          let pages = url.pathname
            .slice(1)
            .split("/")
            .map((v) => v.charAt(0).toUpperCase() + v.slice(1))
            .filter((v) => v.length > 1 && v.length < 20);

          suggestions = suggestions.concat(pages);
        }
        // port
        if (url.port.length) {
          suggestions.push(url.port);
        }

        // hash
        if (url.hash.length) {
          let hash = url.hash.slice(1);
          hash = hash.charAt(0).toUpperCase() + hash.slice(1);
          suggestions.push(hash);
        }
        // search
        if (url.search.length) {
          let params = [];
          for (const [key, value] of url.searchParams) {
            params.push(`${key}=${value}`);
          }
          suggestions = suggestions.concat(params);
        }

        this.$store.commit("updateStateFormURL", { name_suggestions: suggestions });
        // console.log(url, "url");
      }

      // if (
      //   newValue !== null &&
      //   newValue.length &&
      //   (this.form_url_name === null || !this.form_url_name.length)
      // ) {
      //   const url = newValue.toLowerCase();
      //   var url_match = url.match(/(?:https?:\/\/)?(?:[^./]+\.)?([^./]+)(?:\.[^./]+)/);
      //   console.log(url_match, "url_match");
      //   if (url_match) {
      //     const newName = url_match[1].charAt(0).toUpperCase() + url_match[1].slice(1);
      //     this.$store.commit("updateStateFormURL", { name: newName });
      //   } else {
      //     console.error("URL can not be parsed!");
      //   }
      // }
    },
  },
  computed: {
    form_url_modal: {
      get() {
        return this.$store.state.form_url.modal;
      },
      set(value) {
        this.$store.commit("updateStateFormURL", { modal: value });
      },
    },
    form_url_url: {
      get() {
        return this.$store.state.form_url.url;
      },
      set(value) {
        this.$store.commit("updateStateFormURL", { url: value });
      },
    },
    form_url_name: {
      get() {
        return this.$store.state.form_url.name;
      },
      set(value) {
        this.$store.commit("updateStateFormURL", { name: value });
      },
    },
    form_url_note: {
      get() {
        return this.$store.state.form_url.note;
      },
      set(value) {
        this.$store.commit("updateStateFormURL", { note: value });
      },
    },
    form_url_location: {
      get() {
        return this.$store.state.form_url.location;
      },
      set(value) {
        console.log("here");
        this.$store.commit("updateStateFormURL", { location: value });
      },
    },
    form_name_suggestions() {
      return this.$store.state.form_url.name_suggestions;
    },
  },
};
</script>
